import { getBoggleBadgePointsForLevel, type BoggleBadgeDefinition } from '../types'

export const straightBadgeDefinition: BoggleBadgeDefinition = {
  category: 'letters',
  description: 'Play a word that contains 3 consecutive alphabetical letters',
  iconId: 'straight',
  id: 'straight',
  level: 'uncommon',
  lockedReveal: 'reveal',
  name: 'Straight',
  points: getBoggleBadgePointsForLevel('uncommon'),
}
